var map = {
	"./ar-SA.md": 94471,
	"./be-BY.md": 79456,
	"./bg-BG.md": 3060,
	"./bn-BD.md": 83400,
	"./ca-ES.md": 66474,
	"./cs-CZ.md": 75001,
	"./da-DK.md": 69450,
	"./de-DE.md": 70476,
	"./el-GR.md": 2544,
	"./en-GB.md": 24418,
	"./en-US.md": 39603,
	"./es-ES.md": 13006,
	"./fa-IR.md": 66378,
	"./fi-FI.md": 56340,
	"./fr-FR.md": 11686,
	"./he-IL.md": 72110,
	"./hi-IN.md": 97588,
	"./hr-HR.md": 8054,
	"./hu-HU.md": 22252,
	"./id-ID.md": 70596,
	"./it-IT.md": 87716,
	"./ja-JP.md": 78987,
	"./km-KH.md": 30789,
	"./ko-KR.md": 64133,
	"./lo-LA.md": 94630,
	"./me-ME.md": 438,
	"./mk-MK.md": 20238,
	"./ml-IN.md": 25126,
	"./ne-NP.md": 71423,
	"./nl-NL.md": 46506,
	"./no-NO.md": 26172,
	"./pl-PL.md": 27842,
	"./pt-BR.md": 32974,
	"./pt-PT.md": 68642,
	"./ro-RO.md": 54596,
	"./ru-MD.md": 58532,
	"./ru-RU.md": 19236,
	"./sh-HR.md": 18953,
	"./si-LK.md": 72079,
	"./sk-SK.md": 8418,
	"./so-SO.md": 72074,
	"./sq-AL.md": 39515,
	"./sq-MK.md": 92042,
	"./sr-CS.md": 79363,
	"./sr-SP.md": 89562,
	"./sv-SE.md": 98625,
	"./tg-TJ.md": 70575,
	"./th-TH.md": 20130,
	"./tk-TM.md": 44150,
	"./tr-TR.md": 17734,
	"./tu-TI.md": 22456,
	"./uk-UA.md": 1688,
	"./ur-PK.md": 20110,
	"./vi-VN.md": 75813,
	"./zh-CN.md": 74641,
	"./zu-ZA.md": 90824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7169;